"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
exports.default = (function (props) { return (React.createElement("svg", __assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 700 700", className: classNames('sok-svg-icon', props.className) }),
    React.createElement("path", { fill: "#fff", d: "M33.8 80.24h629v538h-629z", "data-name": "Layer 3" }),
    React.createElement("path", { d: "M75 700q-31.24 0-53.12-21.87T0 625V75q0-31.24 21.88-53.12T75 0h550q31.24 0 53.13 21.88T700 75v550q0 31.26-21.87 53.13T625 700zm517.19-440.62q7.82-7.81 7.81-18t-7.81-18l-34.39-34.31q-7.8-7.83-18-7.83t-18 7.82L287.5 423.44 178.13 314.07q-7.81-7.81-18-7.82t-18 7.82l-34.33 34.37q-7.81 7.82-7.81 18t7.81 18l162.5 162.5q6.25 7.82 17.19 7.81t17.19-7.81z", fill: "#009b00", "data-name": "Layer 4" }))); });
//# sourceMappingURL=CheckSquare.js.map